import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'sdpost-page-error',
  templateUrl: './page-error.component.html',
  styleUrls: [
    '../../../../../shared/ui/src/lib/styles/_shared/error-page.scss',
    './page-error.component.scss'
  ]
})
export class PageErrorComponent implements OnInit {
  constructor(private readonly titleService: Title) {
    this.titleService.setTitle('Sorry, an error has occurred');
  }

  ngOnInit() {}
}
